import { Check, ChevronDown, ChevronUp } from "@tamagui/lucide-icons";
import { useState } from "react";
import type { FontSizeTokens, SelectProps } from "tamagui";
import { getFontSize, Select, YStack } from "tamagui";
import { LinearGradient } from "tamagui/linear-gradient";

type SelectFormProps = SelectProps & {
  items: { label: string; value: string }[];
};

export function SelectForm(props: SelectFormProps) {
  const [val, setVal] = useState(props.defaultValue ?? "");

  const items = props.items;

  return (
    <Select
      value={val}
      disablePreventBodyScroll
      {...props}
      onValueChange={(value) => {
        setVal(value);
        props.onValueChange?.(value);
      }}
    >
      <Select.Trigger
        width={220}
        iconAfter={ChevronDown}
        flex={1}
        backgroundColor={"#fff"}
        borderRadius={0}
      >
        <Select.Value
          placeholder="Select..."
          fontSize={16}
          marginLeft="$medium"
        />
      </Select.Trigger>

      <Select.Content zIndex={200000}>
        <Select.ScrollUpButton
          alignItems="center"
          justifyContent="center"
          position="relative"
          width="100%"
          height={50}
        >
          <YStack zIndex={10}>
            <ChevronUp size={20} />
          </YStack>
          <LinearGradient
            start={[0, 0]}
            end={[0, 1]}
            fullscreen
            colors={["$background", "transparent"]}
          />
        </Select.ScrollUpButton>

        <Select.Viewport
          animation="quick"
          animateOnly={["transform", "opacity"]}
          enterStyle={{ x: 0, y: -10 }}
          exitStyle={{ x: 0, y: 10 }}
          borderRadius={0}
          minWidth={250}
          backgroundColor={"#fff"}
          shadowColor={"#000"}
          shadowOpacity={0.2}
          shadowRadius={4}
          shadowOffset={{ width: 0, height: 2 }}
        >
          <Select.Group backgroundColor={"#fff"} minWidth={250}>
            <Select.Label>Options</Select.Label>
            {items.map((item, i) => {
              return (
                <Select.Item index={i} key={item.value} value={item.value}>
                  <Select.ItemText>{item.label}</Select.ItemText>
                  <Select.ItemIndicator marginLeft="auto">
                    <Check size={16} />
                  </Select.ItemIndicator>
                </Select.Item>
              );
            })}
          </Select.Group>
          {/* Native gets an extra icon */}
          {props.native && (
            <YStack
              position="absolute"
              right={0}
              top={0}
              bottom={0}
              alignItems="center"
              justifyContent="center"
              pointerEvents="none"
            >
              <ChevronDown
                size={getFontSize((props.size as FontSizeTokens) ?? "$true")}
              />
            </YStack>
          )}
        </Select.Viewport>

        <Select.ScrollDownButton
          alignItems="center"
          justifyContent="center"
          position="relative"
          width="100%"
        >
          <YStack zIndex={10}>
            <ChevronDown size={20} />
          </YStack>
          <LinearGradient
            start={[0, 0]}
            end={[0, 1]}
            fullscreen
            colors={["transparent", "$background"]}
          />
        </Select.ScrollDownButton>
      </Select.Content>
    </Select>
  );
}
